export default {
  path: '/draw-record',
  meta: {
    title: '我的往期',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/draw-record`),
}



// WEBPACK FOOTER //
// ./src/views/MoreTicket/router.js